import React from "react";
import genRequest from "includes/request";
import { useQuery, useQueries } from "react-query";
import useAccount from "classes/Accounts/hooks/useAccount";
import { t } from "i18next";
import { useMediaQuery } from "react-responsive";
import clsx from "clsx";

export default function LikePostBtn(props) {
	const { account } = useAccount();
	const { postId, postTypeId, setIsOpen } = props;
	const isMobile = useMediaQuery({ query: "(max-width: 700px)" });

	// Le compteur = total des RÉACTIONS du post uniquement. Les likes ne sont plus
	// comptés, et cliquer sur le bouton ne "like" plus rien : seul un clic sur un
	// émoji (dans le popper, ouvert au survol) fait bouger le compteur.
	//
	// On somme exactement les mêmes requêtes par émoji que le popper : une par
	// émoji dispo (`.../PostIdAndReactionId/{postId}/{reactionId}`). Mêmes clés →
	// cache partagé (aucune requête en double) et reprise automatique de la mise à
	// jour optimiste faite au clic. On compte des utilisateurs UNIQUES par émoji
	// pour rester juste même si d'anciens doublons traînent en base.
	const { data: availReactions } = useQuery(
		["Lt_PostAvailableReaction", "PostId", postId],
		() => genRequest(`LT_DefaultReactionOfPostForCompany/ofPostTypeIdAndCompanyId/${postTypeId}/${account.CompanyId}`),
		{ enabled: (postTypeId && account?.CompanyId) ? true : false }
	);
	const reactionTypeId = availReactions?.[0]?.ReactionTypeId;

	const { data: emojis } = useQuery(
		["Reactions", "Typed", reactionTypeId],
		() => genRequest("Reactions/Typed/" + reactionTypeId),
		{ enabled: reactionTypeId ? true : false }
	);

	const emojiCounts = useQueries(
		(emojis || []).map((e) => ({
			queryKey: ["LT_Employe_Reaction_Post", "PostIdAndReactionId", postId, e.ReactionId],
			queryFn: () => genRequest("LT_Employe_Reaction_Post/PostIdAndReactionId/" + postId + "/" + e.ReactionId),
			enabled: postId ? true : false,
		}))
	);

	const countUniqueUsers = (arr) => (Array.isArray(arr) ? new Set(arr.map((r) => r.EmployesId)).size : 0);
	const displayCount = emojiCounts.reduce((sum, q) => sum + countUniqueUsers(q.data), 0);

	return (
		<div
			className={"post-likes-cont d-flex align-items-center cursor-pointer" + (props.className ? " " + props.className : "")}
			title={displayCount + " " + t("Posts.REACTIONS", { count: displayCount })}
			onMouseEnter={() => setIsOpen(true)}
		>
			<div className="d-flex align-items-center">
				<span className={clsx("icons icon-bulle-like", isMobile ? "f-16" : "f-10")}></span>
				<div className="post-likes-count ms-1">{displayCount}</div>
			</div>
		</div>
	);
}
